(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter =
          !isLargeScreen &&
          window.location.hash === '#footer-signup_form' &&
          this.querySelector('#footer-signup_form') !== null;

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  (() => {
    const mobileMenuOpenClass = 'mobile-menu-is-open';
    const mobileQuery = window.matchMedia('(max-width: 767px)');

    const syncMobileMenuOverlayState = () => {
      const disclosures = document.querySelectorAll('main-menu .main-menu__disclosure');
      const isOpen = Array.from(disclosures).some((disclosure) => disclosure.open);
      document.documentElement.classList.toggle(mobileMenuOpenClass, mobileQuery.matches && isOpen);
    };

    const initMobileMenuOverlayState = () => {
      const disclosures = document.querySelectorAll('main-menu .main-menu__disclosure');

      disclosures.forEach((disclosure) => {
        if (disclosure.dataset.mobileOverlayWatcher === 'true') return;

        disclosure.dataset.mobileOverlayWatcher = 'true';
        disclosure.addEventListener('toggle', syncMobileMenuOverlayState);

        const observer = new MutationObserver(syncMobileMenuOverlayState);
        observer.observe(disclosure, { attributes: true, attributeFilter: ['open'] });
      });

      syncMobileMenuOverlayState();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initMobileMenuOverlayState);
    } else {
      initMobileMenuOverlayState();
    }

    document.addEventListener('shopify:section:load', initMobileMenuOverlayState);

    if (mobileQuery.addEventListener) {
      mobileQuery.addEventListener('change', syncMobileMenuOverlayState);
    } else {
      mobileQuery.addListener(syncMobileMenuOverlayState);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-youtube"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pyt-videos')) {
    customElements.define('pyt-videos', class extends HTMLElement {
      connectedCallback() {
        this.initFrame = requestAnimationFrame(() => this.initialize());
      }

      initialize() {
        if (!this.isConnected) return;
        if (this.controller) return;
        this.track = this.querySelector('.pyt__track');
        if (!this.track) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.cards = Array.from(this.track.children);
        this.dots = Array.from(this.querySelectorAll('[data-index]'));
        this.active = 0;
        this.addEventListener('click', event => this.onClick(event), options);
        this.addEventListener('load', event => this.checkImage(event.target), { ...options, capture: true });
        this.addEventListener('error', event => this.checkImage(event.target, true), { ...options, capture: true });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track || this.track.scrollWidth <= this.track.clientWidth) return;
          const rtl = getComputedStyle(this.track).direction === 'rtl';
          const movement = { ArrowRight: rtl ? -1 : 1, ArrowLeft: rtl ? 1 : -1 };
          let index;
          if (event.key in movement) index = this.active + movement[event.key];
          else if (event.key === 'Home') index = 0;
          else if (event.key === 'End') index = this.cards.length - 1;
          else return;
          event.preventDefault();
          this.goTo(index);
        }, options);
        this.querySelectorAll('img').forEach(img => {
          if (img.complete) this.checkImage(img, !img.naturalWidth);
        });
        const navigation = this.querySelector('.pyt__nav');
        if (navigation) {
          navigation.hidden = false;
          const visible = new Map();
          this.observer = new IntersectionObserver(entries => {
            entries.forEach(entry => visible.set(entry.target, entry.intersectionRatio));
            if ((visible.get(this.cards[this.active]) || 0) >= .6) return;
            const first = this.cards.findIndex(card => (visible.get(card) || 0) >= .6);
            if (first >= 0) this.setActive(first);
          }, { root: this.track, threshold: [0, .6, 1] });
          this.cards.forEach(card => this.observer.observe(card));
        }
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.initFrame);
        this.controller?.abort();
        this.controller = null;
        this.observer?.disconnect();
        this.querySelectorAll('iframe').forEach(frame => frame.remove());
        this.querySelectorAll('.pyt__trigger').forEach(link => { link.hidden = false; });
      }

      checkImage(img, failed = false) {
        if (!(img instanceof HTMLImageElement) || !img.closest('.pyt__trigger')) return;
        if (!failed && img.naturalWidth > 120) return;
        if (img.dataset.fallback) {
          img.hidden = true;
          return;
        }
        const id = img.closest('[data-video-id]').dataset.videoId;
        if (!/^[A-Za-z0-9_-]{11}$/.test(id)) return;
        const current = img.currentSrc || img.src;
        img.dataset.fallback = 'true';
        img.closest('picture')?.querySelectorAll('source').forEach(source => source.remove());
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        const fallback = `https://i.ytimg.com/vi/${id}/hqdefault.jpg`;
        if (current === fallback && (failed || img.naturalWidth <= 120)) {
          img.hidden = true;
          return;
        }
        img.src = fallback;
      }

      setActive(index) {
        this.active = index;
        this.dots.forEach((dot, i) => {
          if (i === index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        const previous = this.querySelector('[data-step="-1"]');
        const next = this.querySelector('[data-step="1"]');
        if (previous) previous.disabled = index === 0;
        if (next) next.disabled = index === this.cards.length - 1;
      }

      goTo(index) {
        index = Math.max(0, Math.min(index, this.cards.length - 1));
        const card = this.cards[index];
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        const trackRect = this.track.getBoundingClientRect();
        const cardRect = card.getBoundingClientRect();
        const delta = rtl ? cardRect.right - trackRect.right : cardRect.left - trackRect.left;
        this.track.scrollBy({ left: delta, behavior: 'instant' });
        this.setActive(index);
      }

      onClick(event) {
        const navigation = event.target.closest('[data-index], [data-step]');
        if (navigation && this.contains(navigation)) {
          const index = navigation.hasAttribute('data-index') ? Number(navigation.dataset.index) : this.active + Number(navigation.dataset.step);
          this.goTo(index);
          return;
        }
        const link = event.target.closest('.pyt__trigger');
        if (!link || !this.contains(link) || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
        const id = link.dataset.videoId;
        if (!/^[A-Za-z0-9_-]{11}$/.test(id)) return;
        event.preventDefault();
        if (!this.dispatchEvent(new CustomEvent('pyt:before-play', { bubbles: true, cancelable: true, detail: { videoId: id } }))) return;
        this.querySelectorAll('iframe').forEach(frame => {
          frame.parentElement.querySelector('.pyt__trigger').hidden = false;
          frame.remove();
        });
        const frame = document.createElement('iframe');
        frame.title = link.dataset.title;
        frame.src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&playsinline=1&rel=0`;
        frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        frame.allowFullscreen = true;
        frame.referrerPolicy = 'strict-origin-when-cross-origin';
        link.hidden = true;
        link.parentElement.append(frame);
        frame.focus();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
